export default {
  title: "Attività",
  subtitle: "Tutte le attività della piattaforma",
  searchPlaceholder: "Cerca per attività o proprietario...",
  loadError: "Impossibile caricare le attività",
  retry: "Riprova",
  empty: "Nessuna attività corrisponde ai filtri.",
  openRowAria: "Apri attività {{name}}",
  filters: {
    status: "Stato",
    statusAll: "Tutte",
    statusActive: "Attive",
    statusInactive: "Inattive",
    visibility: "Visibilità",
    visibilityAll: "Tutte",
    visibilityVisible: "Visibili",
    visibilityHidden: "Nascoste",
    discounts: "Sconti",
    discountsAll: "Tutti",
    discountsActive: "Sconti attivi",
    category: "Categoria",
    categoryAll: "Tutte",
    paymentModel: "Metodo di pagamento",
    paymentModelAll: "Tutti",
  },
  paymentModels: {
    upfront: "Anticipato",
    deposit: "Deposito",
    receiptBased: "A ricevuta",
  },
  categories: {
    restaurant: "Ristorante",
    attraction: "Esperienza",
    genericService: "Servizio",
  },
  columns: {
    name: "Attività",
    category: "Categoria",
    owner: "Proprietario",
    paymentModel: "Metodo di pagamento",
    commission: "Commissione",
    visibility: "Visibilità",
    discount: "Sconto",
  },
  cells: {
    visible: "Visibile",
    hidden: "Nascosta",
    discountActive: "Attivo",
    discountNone: "—",
  },
} as const;
